/**
 * Schermteksten in het Japans.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const ja: Teksten = {
  kamerOphalen: "ルームを取得中…",
  kamerWerktNiet: "このルームは使えません",
  serverReageertNiet: "サーバーが応答しません",
  probeerOpnieuw: "もう一度試す",
  vraagNieuweCode: "コードを共有した人に新しいものを頼んでね。ルームは数時間で有効期限が切れるよ。",
  welkeTaalSprekJij: "何語を話す？",
  jouwStem: "翻訳時のあなたの音声",
  man: "男性",
  vrouw: "女性",
  pincode: "PINコード",
  pincodeUitleg: "コードを共有した人から受け取ってね。",
  gaDeKamerIn: "ルームに入る",
  kiesEerstJeTaal: "最初に言語を選んでね",
  microfoonAanvragen: "マイクを要求中…",
  toestemmingUitleg: "ブラウザがマイクの使用許可を求めるよ。許可しないとテキスト入力しかできなくなるよ。",
  microfoonTestLink: "まずマイクをテストしよう",
  stemGaatMee: "このルームでは、翻訳のほかに自分の生の声も相手に届くよ。",
  alleenChatMelding: "この会話はチャットのみだよ。メッセージを入力して翻訳を読んでね。読み上げはしないよ。",
  verlooptOm: "有効期限：",
  nooitVasteKamer: "期限なし、固定ルーム",
  kamer: "ルーム",
  tolkgesprek: "通話通訳",
  juisteKamer: "正しいルームに入ったよ。まもなくここで会話に参加できるよ。",
  jij: "あなた",
  deAnder: "相手",
  verbinden: "接続中…",
  verbonden: "接続済み",
  verbindingKwijt: "接続が切れました。再接続中…",
  wachtenOpAnder: "入室したよ。相手がQRコードをスキャンするのを待ってね。",
  allebeiInDeKamer: "お互いにルームに入ったよ。",
  anderIsWeg: "相手が退出したよ",
  anderSpreekt: "相手が話しています…",
  jeKuntErNietIn: "入れません",
  overgenomenTitel: "別の端末で続行中",
  overgenomenUitleg: "この会話はたった今、別の端末で開かれました。そちらで会話を続けてください。",
  terug: "戻る",
  geluidStaatUit: "消音モードだよ。画面のどこかをタップしてね。",
  tikHier: "ここをタップ",
  bewaardTot: '{tijd} まで保存されます',
  bewaardVast: "固定ルームだよ。メッセージは30日間保存されるよ。",
  spreekIn: "話す",
  luisteren: "聞き取り中… タップで停止",
  uitschrijven: "テキスト化中…",
  tijdOmTeVerbeteren: "修正時間",
  altijdZelfVersturen: "常に自分で確認して送信",
  jijVerstuurtZelf: "自分で送信する",
  uit: "オフ",
  sec: "秒",
  vertalingMeteenAfspelen: "翻訳をすぐに再生",
  typHierJeBericht: "メッセージを入力…",
  stuur: "送信",
  geenOpnameMogelijk: "このブラウザは録音に対応していません。テキスト入力は使えるよ。",
  verstaanAls: "聞き取り結果",
  tellerStaatStil: "タイマー停止中",
  versturen: "送信する",
  wis: "消去",
  jijZei: "あなたの発言",
  vertaald: "翻訳",
  duimOmhoog: "正しい",
  duimOmlaag: "正しくない",
  opnieuwProberenKnop: "より良いモデルで再試行",
  opnieuwProberenBezig: "再翻訳中…",
  duimTranscriptWoordenlijstUitnodiging: "聞き間違い？単語リストで修正してね：",
  instellingenAanpassen: "設定を変更",
  geldtVoorJullieBeiden: "お互いに適用",
  alleenVoorJou: "あなただけに適用",
  stuurMijnStemMee: "自分の音声を届ける",
  verbeterSpelfouten: "テキストの誤字を修正する",
  verbeterSpelfoutenUit: "オフにすると、聞き間違えた通りにテキストが表示されるよ。",
  alleenChat: "チャットのみ：音声なし、マイクなし",
  alleenChatUitleg: "お互いに入力するよ。翻訳と元のテキストが表示されて、読み上げはしないよ。",
  aangepastDoorDeAnder: "相手が設定を変更したよ。",
  foutSpraak: "翻訳は完了したけど、音声が出せなかったよ。",
  foutSpraakQuota: "今日の音声制限に達したよ。テキスト翻訳は引き続き使えるよ。音声は明日復活するよ。",
  foutBudgetKamer: "この会話は上限に達したから、翻訳は一時停止中だよ。会話を作った人が上限を上げれば、すぐにまた使えるよ。",
  foutBudgetMaand: "アプリの今月の予算を使い切ったよ。管理者が調整すれば、また翻訳できるようになるよ。",
  foutTaal: "その言語は選べないよ。お互いに同じ言語になってしまうよ。",
  origineel: "原文",
  vertalen: "翻訳中…",
  vertalenMislukt: "翻訳に失敗したよ。",
  opnieuwAfspelen: "翻訳を再再生",
  hoorDeAnder: "相手の生の声を聴く",
  woordenlijst: "お助け単語リスト",
  woordenlijstUitleg: "アプリが名前や専門用語をいつも聞き間違える？ここで正しい意味を登録してね。",
  hijHoort: "聞こえた言葉…",
  jijBedoelt: "本当の言葉…",
  ookVolgendeGesprekken: "次回の会話でも使う — オフの場合はこの会話だけ",
  voegToe: "追加する",
  bezig: "処理中…",
  lijstNietGeladen: "リストを読み込めなかったよ。",
  toevoegenMislukt: "追加に失敗したよ。",
  verwijderenMislukt: "削除に失敗したよ。",
  overal: "常に使用",
  verwijder: "削除",
  overDitGesprek: "この会話について",
  toon: "翻訳のトーン",
  sfeer: "会話の雰囲気",
  jouwPlek: "あなたの場所",
  hoeHetWerkt: "サーバーが録音を書き起こし、一度に翻訳するよ。あなたの生の声も相手に届くよ。",
  kleinereTekst: "文字を小さく",
  grotereTekst: "文字を大きく",
  insprekenVerbergen: "音声入力を非表示",
  insprekenTonen: "音声入力を表示",
  toetsenbordVerbergen: "キーボードを非表示",
  toetsenbordTonen: "キーボードを表示",
  vormAutomatisch: "自動",
  vormInformeel: "ため口",
  vormFormeel: "敬語",
  sfeerNeutraal: "標準",
  sfeerZakelijk: "ビジネス",
  sfeerOfficieel: "公式・フォーマル",
  sfeerVriendschappelijk: "フレンドリー",
  sfeerPartner: "パートナー",
  foutKamerVol: "このルームは満員だよ。2人までしか入れないよ。",
  plekBezetTitel: "きみの席はもう使われているよ",
  plekBezetUitleg: "この会話のきみの側に、きみの言語で、もう誰かがいるよ。たいていはきみ自身で、別の端末か別のタブでまだ開いたままなんだ。そっちで閉じてから、もう一度試してね。席が空くまで1分半かかることもあるよ。",
  plekBezetWissel: "きみ自身かな？WISSEL と入力すると、会話をこの端末に移せるよ。もう一方の端末は閉じるよ。",
  plekBezetKnop: "この端末に移す",
  foutKamerVerlopen: "このルームは期限切れか、閉じられているよ。",
  foutKamerOnbekend: "このルームは存在しないよ。",
  foutPinNodig: "このルームにはPINコードが必要だよ。",
  foutPinFout: "PINコードが間違っているよ。",
  foutProtocol: "アプリとサーバーが通信できないよ。ページを更新してね。",
  foutMicroGeweigerd: "マイクの使用が拒否されたよ。アドレスバーの鍵マークをクリックして許可してね。",
  foutGeenMicro: "マイクが見つからないよ。接続してもう一度試してね。",
  foutMicroInGebruik: "マイクが別のアプリで使われているよ。それを閉じてからもう一度試してね。",
  foutGeenHttps: "マイクは安全な接続でのみ使えるよ。httpsでこのページを開き直してね。",
  foutMicroOnbekend: "マイクを起動できなかったよ。",
  foutNietsOpgenomen: "何も録音されなかったよ。マイクはオンになっている？",
  foutNietsGehoord: "何も聞こえなかったよ。マイクがオンで、十分な音量で話している？",
  foutOpnameTeLang: "録音が長すぎるよ。もっと短く区切って話してね。",
  foutMicroGedempt: "マイクがミュートになっているよ。ミュートを解除してもう一度試してね。",

  // --- microfoontest ---
  micTitel: "マイクテスト",
  micOnderschrift: "4つのテストを連続で、それぞれ5秒。ずっと話し続けてね。",
  micStart: "テストを開始",
  micTest1: "1. 認識のみ",
  micTest2: "2. 録音のみ",
  micTest3: "3. 同時 — 録音が先",
  micTest4: "4. 同時 — 認識が先",
  micFase1: "4分の1：認識のみ — 短い文を言ってみて",
  micFase2: "4分の2：録音のみ — 話し続けて",
  micFase3: "4分の3：録音が先、次に認識 — 話し続けて",
  micFase4: "4分の4：認識が先、次に録音 — 話し続けて",
  micKlaar: "完了",
  micGehoord: "聞こえた内容",
  micOpnameformaat: "録音フォーマット",
  micGeen: "なし",
  micBeveiligd: "安全な接続",
  micJa: "はい",
  micNee: "いいえ",
  micBrowser: "ブラウザ",
  micGeenHttps: "https でないとブラウザはマイクを使わせてくれないよ。localhost なら大丈夫。",
  micGeenHerkenning: "このブラウザには音声認識がないよ。",
  micZegIets: "何か話してみて…",
  micWoordenBinnen: "言葉が届いているよ",
  micKonNietStarten: "開始できなかった",
  micGeenRecorder: "このブラウザは MediaRecorder を知らないよ。",
  micOpnemen: "録音中…",
  micNietsOpgenomen: "何も録音されなかった",
  micGeenMicrofoon: "マイクがない",
  micOpnameEerst: "録音が先…",
  micHerkenningEerst: "認識が先…",
  micOpnameStarttNiet: "録音が始まらなかった",
  micSamenGelukt: "同時に成功。録音 {kb} kB。",
  micAlleenOpname: "録音はできたけど、認識はできなかった。",
  micAlleenHerkenning: "認識はできたけど、録音はできなかった。",
  micGeenVanBeide: "どちらもできなかった。",
  micNetwerkFout: "音声認識がサーバーに接続できなかったよ。",
  micAfgebroken: "録音が中断されたよ。",
  verslagTitel: "会話記録",
  verslagWie: "話者",
  verslagOrigineel: "原文",
  verslagVertaling: "翻訳",
  verslagSpreker: "話者 {x}",
  verslagBerichten: "メッセージ",
  verslagGemaaktOp: "作成日時",
  verslagGeenOpname: "逐語的な録音ではありません。",
  verslagNootOrigineel: "「原文」は、アプリが話者の発言を理解したとおりのテキストです。",
  verslagNootCorrectie: "スペル修正がオンでした：小さな入力ミスは修正されています。",
  verslagNootAangepast: "話した人は送信前にテキストを修正できました。",
  verslagGesproken: "音声",
  verslagGetypt: "入力",
  verslagMislukt: "翻訳に失敗しました。相手はこの文を自分の言語で見ていません。",
  verslagNietKlaar: "この記録の作成時点で、翻訳はまだ完了していませんでした。",
  verslagVertrouwelijk: "機密。",
  verslagAlleenDeelnemers: "この記録には私的な会話の内容が含まれており、参加者のみを対象としています。",
  verslagGewist: "会話の削除日時：{tijd}。その後、この記録を再作成することはできません。",
  verslagGewistVast: "固定ルーム：各メッセージは送信から30日後に削除されます。それより古いメッセージはこの記録に含まれません。",
};
